export default "__VITE_ASSET__Dsc8aZuK__"